import { render, staticRenderFns } from "./MensagemDoChatDeSuporte.vue?vue&type=template&id=60c3d428&scoped=true&"
import script from "./MensagemDoChatDeSuporte.vue?vue&type=script&lang=ts&"
export * from "./MensagemDoChatDeSuporte.vue?vue&type=script&lang=ts&"
import style0 from "./MensagemDoChatDeSuporte.vue?vue&type=style&index=0&id=60c3d428&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c3d428",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
